import InvoicesProvider from "../../../../pages/Transactions/InvoiceProvider";
import InvoiceProviderNewEdit from "../../../../pages/Transactions/InvoiceProvider/NewEdit";
import DetailProvider from "../../../../pages/Transactions/InvoiceProvider/Detail";

const routerInvoiceProvider = [
    {
        key: "invoiceProvider",
        path: "/transactions/invoiceProvider",
        element: <InvoicesProvider />,
    },
    {
        key: "invoiceProvider",
        path: "/transactions/invoiceProvider/new",
        element: <InvoiceProviderNewEdit />,
    },
    {
        key: "invoiceProvider",
        path: "/transactions/invoiceProvider/:id",
        element: <DetailProvider />,
    },
]

export default routerInvoiceProvider
